import React from "react";

import { actions } from "./data";
import { Button, Tooltip, Kbd, Text, Space, ActionIcon } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { Spotlight, spotlight } from "@mantine/spotlight";

import { IconSearch } from "@tabler/icons-react";

function SpotlightDocusaurus() {
  const isMobile = useMediaQuery("(max-width: 768px)", true, {
    getInitialValueInEffect: true,
  });

  return (
    <>
      <Tooltip label="Open search documentation..." aria-label="Open search documentation tooltip">
        {!isMobile ? (
          <Button
            autoContrast
            leftSection={<IconSearch size={14} />}
            variant="light"
            color="gray"
            size="compact-lg"
            aria-label="Open Search documentation..."
            onClick={spotlight.open}
          >
            <Text size="sm">Search</Text>
            <Space w="lg" />
            <Text dir="ltr">
              <Kbd style={{ border: "none" }}>⌘ + K</Kbd>
            </Text>
          </Button>
        ) : (
          <ActionIcon
            autoContrast
            variant="light"
            color="gray"
            size="lg"
            aria-label="Open Search documentation..."
            onClick={spotlight.open}
          >
            <IconSearch />
          </ActionIcon>
        )}
      </Tooltip>
      <Spotlight
        actions={actions}
        nothingFound="Nothing found..."
        highlightQuery
        scrollable
        searchProps={{
          leftSection: <IconSearch />,
          placeholder: "Search documentation...",
        }}
      />
    </>
  );
}

export default SpotlightDocusaurus;
